import { Box, Flex, Heading, Image, List, ListItem, Text, useBreakpointValue, VStack } from "@chakra-ui/react";
import { DelayedFlight, DamagedLuggage, MoneyProfit } from "@airhelp/icons";
import { Container } from "components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { SbEditableComponentProps } from "types/storyblok";
import type { AirHelpPlusBenefitsSectionProps } from "./AirHelpPlusBenefitsSection.d";

const icons = {
  DelayedFlight,
  DamagedLuggage,
  MoneyProfit,
};

export const AirHelpPlusBenefitsSection = ({
  heading,
  imageUrlDesktop,
  imageUrlMobile,
  imageUrlTablet,
  imageAlt,
  benefits,
  button,
  sbEditable,
}: SbEditableComponentProps<AirHelpPlusBenefitsSectionProps>) => (
  <Box
    {...sbEditable}
    w="fit-content"
    bg="greyscale.300"
    borderRadius="3xl"
    mx={{ base: 4, md: 4, xl: "auto" }}
    px={{ base: 4, lg: 4, xl: 12 }}
  >
    <Container>
      <Flex flexDir="column" align="center" py={{ base: 10, lg: 20 }}>
        <Box textAlign="center" maxW={{ base: "279px", md: "576px", lg: "800px" }}>
          {!isEmpty(heading) && <RichtextAdapter content={heading} />}
        </Box>
        <Flex py={10} flexDir={{ base: "column", xl: "row" }}>
          <Image
            src={useBreakpointValue({ base: imageUrlMobile, md: imageUrlTablet, xl: imageUrlDesktop }, { ssr: true })}
            borderRadius="xl"
            alt={imageAlt}
          />
          <List ml={{ base: "unset", lg: 28 }} mt={{ base: 10, lg: 16, xl: "unset" }}>
            <VStack spacing={{ base: 8, lg: 16 }} align="left">
              {benefits?.map(({ icon, heading, description }) => {
                const Icon = icons[icon];
                return (
                  <ListItem key={heading} display="flex">
                    <Flex
                      boxSize={14}
                      bg="greyscale.100"
                      align="left"
                      justify="center"
                      borderRadius="xl"
                      p={4}
                      mr={{ base: 4, lg: 8 }}
                    >
                      {icon && <Icon boxSize={7} color="primary.500" />}
                    </Flex>
                    <Flex flexDir="column">
                      {heading && (
                        <Heading as="h5" variant="h5" mb={5}>
                          {heading}
                        </Heading>
                      )}
                      {description && (
                        <Text color="greyscale.600" fontSize="md">
                          {description}
                        </Text>
                      )}
                    </Flex>
                  </ListItem>
                );
              })}
            </VStack>
          </List>
        </Flex>
        {button && renderDynamicComponent(button)}
      </Flex>
    </Container>
  </Box>
);
